import React, { useState } from 'react';
import PaymentTable from '../../components/payment/PaymentTable';

const PaymentManagement = () => {
   
  return (
   <>
   <PaymentTable/>
   </>
  )
}

export default PaymentManagement